import Dialog from '@mui/material/Dialog';
import { Box, Button, DialogContent, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './StyleBoard.scss';
import { useState } from 'react';
import { useUpdateImage } from '../../api/styleBoard';
import { UploadResponseItem } from '../../models/cloudinary.models';

interface DescriptionModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  image: UploadResponseItem;
  ResetSelectedImage: () => void;
  setShowSuccess: React.Dispatch<React.SetStateAction<boolean>>;
  setShowError: React.Dispatch<React.SetStateAction<boolean>>;
  setUpdateImages: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DescriptionModal = (props: DescriptionModalProps) => {
  const {
    open,
    setOpen,
    image,
    ResetSelectedImage,
    setShowSuccess,
    setShowError,
    setUpdateImages,
  } = props;

  const [description, setDescription] = useState(
    image.metadata.find((item) => item.label === 'image_notes')?.value || ''
  );
  const mutation = useUpdateImage();

  const handleError = () => {
    setOpen(false);
    setShowError(true);
    ResetSelectedImage();
  };

  const handleSuccess = () => {
    setOpen(false);
    setShowSuccess(true);
    ResetSelectedImage();
  };

  return (
    <>
      <Dialog
        data-testid="description-modal"
        className="description-modal"
        open={open}
        onClose={() => {
          setOpen(false);
          ResetSelectedImage();
        }}
        aria-labelledby="auth-dialog-title"
      >
        <Box className="container">
          <Button
            variant="transparent"
            className="close-btn"
            onClick={() => {
              setOpen(false);
              ResetSelectedImage();
            }}
            sx={{ color: 'white' }}
          >
            <CloseIcon sx={{ fill: '#49454F' }} />
          </Button>
          <DialogContent className="content">
            <Typography variant="h5" className="description-title">
              Add / View Description
            </Typography>
            <textarea
              className="text-box"
              id="homeStylePreferenceOtherDescription"
              name="homeStylePreferenceOtherDescription"
              placeholder="Home Style Description"
              onChange={(e) => setDescription(e.target.value)}
              value={description || ''}
            />
            <Button
              className="save-btn"
              onClick={() =>
                mutation.mutate(
                  {
                    public_id: image.public_id,
                    image_notes:
                      description.toString().replace(/\s+/g, ' ').trim() || '',
                  },
                  {
                    onSuccess: () => {
                      handleSuccess();
                      setUpdateImages(true);
                    },
                    onError: () => handleError(),
                  }
                )
              }
              variant="contained"
            >
              {mutation.isPending ? 'Saving...' : 'Save'}
            </Button>
          </DialogContent>
        </Box>
      </Dialog>
    </>
  );
};
